import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia-titulo" className="w-full bg-cream-50" data-id="element-85" data-mp="4uqdmw6js2tb">
      <div className="mx-auto max-w-content px-5 py-10 sm:px-8 sm:py-16 lg:py-20" data-id="element-86" data-mp="9ucr96qafl2n">
        <div className="grid gap-4 rounded-xl border border-cream-300 bg-cream-100 p-5 sm:gap-8 sm:rounded-2xl sm:p-10 lg:grid-cols-[auto_1fr] lg:items-start lg:gap-12" data-id="element-87" data-mp="9wpikahxr7sd">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-forest-900 sm:h-20 sm:w-20" data-id="element-88" data-mp="js0wiqlisaz2">
            <ShieldCheckIcon className="h-6 w-6 text-moss-400 sm:h-9 sm:w-9" aria-hidden="true" data-id="element-89" data-mp="ns1bcccj6o6n" />
          </div>
          <div data-id="element-90" data-mp="sn6wva20u0u7">
            <p className="font-display text-[11px] font-bold uppercase tracking-[0.18em] text-moss-600 sm:text-xs sm:tracking-[0.2em]" data-id="element-91" data-mp="xjnvwzardzm2">
              Probalo sin riesgo
            </p>
            <h2 id="garantia-titulo" className="mt-2 font-display text-xl font-extrabold leading-tight tracking-tight text-forest-900 sm:mt-3 sm:text-3xl" data-id="element-92" data-mp="12h7bc2j70ifl">
              Garantía de satisfacción de 7 días
            </h2>
            <div className="mt-3 max-w-2xl space-y-2 text-sm leading-relaxed text-forest-800/85 sm:mt-4 sm:space-y-3 sm:text-[15px]" data-id="element-93" data-mp="20r993c3il2sm">
              <p data-id="element-94" data-mp="1vvkeln6cqc36">
                Quiero que puedas conocer el MegaPack Hábitos y comprobar si realmente es para vos.
              </p>
              <p data-id="element-95" data-mp="2oiogvke28cb9">
                Si realizás tu compra y dentro de los primeros 7 días sentís que el contenido no es
                lo que esperabas, podés solicitar un reembolso.
              </p>
              <p className="font-semibold text-forest-900" data-id="element-96" data-mp="2ertr461luul2">Tenés 7 días para probarlo.</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}